import { render } from "./ProjectSection.vue?vue&type=template&id=0cafa0b4&scoped=true"
import script from "./ProjectSection.vue?vue&type=script&lang=js"
export * from "./ProjectSection.vue?vue&type=script&lang=js"

import "./ProjectSection.vue?vue&type=style&index=0&id=0cafa0b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-web-portfolio/vue-web-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cafa0b4"]])

export default __exports__